
export default {
  name: 'icon-status-boarding',
};
